import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedescabrentalsinbanglore() {



  const cardData =
  {
    keyword: 'Mercedes Cab Rentals in Bangalore',
    heading: 'Aaryan Travels: Mercedes Cab Rentals in Bangalore',
    headingDescription: 'Aaryan Travels offers premium Mercedes Cab Rentals in Bangalore for corporate executives, VIP guests, weddings, and luxury travelers who prefer class and comfort in every journey. Whether it’s airport transfers from Kempegowda International Airport, business meetings in Whitefield or Electronic City, or grand wedding entries in Koramangala or Indiranagar, our chauffeur-driven Mercedes sedans provide a refined and elegant travel experience. With uniformed drivers, plush interiors, and on-request amenities like bottled water and Wi-Fi, Aaryan Travels ensures a first-class ride across Bangalore. For those seeking prestige on wheels, our Mercedes cab rentals deliver unmatched sophistication and reliability.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre haven of greenery with rare plant species, serene lakes, and a stunning Glass House modeled after London’s Crystal Palace. The annual flower show here is a major attraction. Joggers, photographers, and nature lovers frequent its peaceful walkways. Lalbagh is Bangalore’s evergreen paradise in the heart of the city."
  },
  {
    "title": "Bangalore Palace",
    "description": "Built in 1878, Bangalore Palace resembles a European castle with Tudor-style architecture, wooden staircases, and grand courtyards. Visitors can explore vintage photographs, royal artifacts, and sprawling palace grounds. Cultural events and concerts are often hosted here. Bangalore Palace is the city’s majestic symbol of royal heritage."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush 300-acre green space with wide walking paths, historic statues, and shaded trees. It is popular among fitness enthusiasts, picnickers, and pet lovers. The nearby State Central Library and High Court add to its charm. Cubbon Park is Bangalore’s refreshing lung space for relaxation and recreation."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple, located on a hilltop in Rajajinagar, is a grand marble shrine dedicated to Lord Krishna. The temple’s peaceful ambiance, devotional chants, and prasadam distribution attract devotees worldwide. Its architecture beautifully blends traditional and modern elements. ISKCON is Bangalore’s beacon of spirituality and peace."
  },
  {
    "title": "Nandi Hills",
    "description": "Situated about 60 km from Bangalore, Nandi Hills is a popular sunrise destination offering stunning panoramic views. The misty hills, ancient fort walls, and cool breeze create a magical atmosphere. Adventure enthusiasts enjoy trekking, cycling, and paragliding. Nandi Hills is Bangalore’s scenic escape at dawn."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s busiest shopping lanes known for fashion, footwear, and accessories at bargain prices. Narrow lanes filled with colorful shops create a vibrant atmosphere. Cafes and street food stalls keep the energy high. Commercial Street is Bangalore’s bustling hub of shopping and style."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is the seat of Karnataka’s state legislature and a masterpiece of Neo-Dravidian architecture. Its imposing structure and massive granite pillars make it a sight to behold. The building is illuminated beautifully on Sundays and public holidays. Vidhana Soudha is Bangalore’s proud symbol of governance and grandeur."
  },
  {
    "title": "UB City",
    "description": "UB City is Bangalore’s premier luxury commercial complex featuring designer stores, fine dining restaurants, and rooftop lounges. The open-air amphitheater hosts live performances and events. The reflective glass architecture adds a modern touch. UB City is Bangalore’s upscale destination for lifestyle and entertainment."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park offers wildlife safaris where visitors can spot tigers, lions, and bears in their natural habitats. It also includes a butterfly park, reptile house, and zoo enclosures. The lush surroundings make it ideal for a family day out. Bannerghatta is Bangalore’s wild retreat into nature."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road are iconic city streets lined with pubs, boutiques, cafés, and shopping centers. Known for nightlife and cultural vibrancy, they remain top hangout spots for youngsters. Festival decorations make the streets sparkle with energy. MG Road is Bangalore’s pulse of urban life."
  }
],



"services": [
  {
    "name": "Mercedes Cab Rentals in Bangalore",
    "description": "Mercedes Cab Rentals in Bangalore offer luxurious and stylish transportation options for business professionals, special occasions, and corporate travel. Featuring a fleet of well-maintained Mercedes vehicles, this service guarantees comfort, punctuality, and a premium travel experience. With professional chauffeurs and flexible rental plans, clients enjoy seamless and sophisticated rides across Bangalore."
  },
  {
    "name": "Chauffeur Mercedes Bangalore",
    "description": "Chauffeur Mercedes Bangalore provides expert-driven Mercedes vehicles with chauffeurs trained in corporate etiquette and customer service. This service is ideal for executives and VIP clients who require dependable, discreet, and comfortable travel with attention to detail and safety."
  },
  {
    "name": "Executive Mercedes Taxi Bangalore",
    "description": "Executive Mercedes Taxi Bangalore delivers high-end taxi services tailored for business travelers seeking prestige and efficiency. The service ensures timely pickups, elegant vehicles, and chauffeurs skilled in navigating city traffic to keep you on schedule with style."
  },
  {
    "name": "Luxury Mercedes Hire Bangalore",
    "description": "Luxury Mercedes Hire Bangalore specializes in premium vehicle rentals for clients looking to make a statement. Whether for corporate events, weddings, or VIP transfers, this service provides top-tier Mercedes models, pristine interiors, and professional drivers for a flawless travel experience."
  },
  {
    "name": "Mercedes Sedan Rental Bangalore",
    "description": "Mercedes Sedan Rental Bangalore offers a range of luxurious sedans perfect for corporate travel, airport transfers, and city tours. With comfortable seating, smooth rides, and impeccable service, these rentals cater to professionals who prioritize quality and comfort."
  },
  {
    "name": "Premium Mercedes Rental Bangalore",
    "description": "Premium Mercedes Rental Bangalore provides clients with access to the latest Mercedes models equipped with advanced features and amenities. The service ensures a superior driving experience supported by professional chauffeurs and flexible rental durations to suit varied business and personal needs."
  },
  {
    "name": "Mercedes SUV Hire Bangalore",
    "description": "Mercedes SUV Hire Bangalore offers spacious and powerful SUVs for clients requiring more room and luxury. Ideal for family trips, corporate group travel, or events, these SUVs combine elegance with versatility and expert chauffeur services."
  },
  {
    "name": "Business Class Mercedes Bangalore",
    "description": "Business Class Mercedes Bangalore caters to professionals seeking executive-level transportation with utmost comfort and reliability. This service includes Mercedes models known for their prestige and advanced features, paired with courteous chauffeurs who understand corporate requirements."
  },
  {
    "name": "Corporate Mercedes Car Rental Bangalore",
    "description": "Corporate Mercedes Car Rental Bangalore provides tailored solutions for companies needing premium transport for employees, clients, and executives. With flexible contracts, maintenance, and professional drivers, businesses benefit from seamless and prestigious mobility options."
  },
  {
    "name": "Affordable Mercedes Cab Bangalore",
    "description": "Affordable Mercedes Cab Bangalore delivers luxury rides at competitive rates, making premium Mercedes transportation accessible to a wider range of clients. This service balances quality, comfort, and budget-conscious pricing without compromising professionalism."
  },
  {
    "name": "Best Mercedes Cab Services Bangalore",
    "description": "Best Mercedes Cab Services Bangalore is renowned for its exceptional fleet, punctuality, and customer satisfaction. Dedicated to providing top-notch service, this offering ensures every ride in a Mercedes is smooth, safe, and memorable."
  },
  {
    "name": "Mercedes with Driver Bangalore",
    "description": "Mercedes with Driver Bangalore offers clients the convenience of hiring Mercedes vehicles complete with professional drivers. This package is perfect for long-distance trips, daily commutes, or special occasions requiring a seamless and stress-free travel experience."
  },
  {
    "name": "Online Mercedes Booking Bangalore",
    "description": "Online Mercedes Booking Bangalore provides a user-friendly digital platform to reserve Mercedes vehicles with ease. The service features instant confirmations, transparent pricing, and real-time tracking to streamline corporate and personal transportation needs."
  },
  {
    "name": "Elite Mercedes Rental Bangalore",
    "description": "Elite Mercedes Rental Bangalore delivers exclusive access to high-end Mercedes models for discerning clients. Focused on luxury, privacy, and impeccable service, this offering is perfect for VIPs, executives, and special event transportation."
  },
  {
    "name": "Hire Mercedes Cab Bangalore",
    "description": "Hire Mercedes Cab Bangalore offers flexible rental options for Mercedes cabs, including hourly, daily, and long-term hires. With a focus on professionalism, comfort, and reliability, this service meets diverse travel demands across Bangalore."
  }
],
"tableData": [
  ["Mercedes Cab Rentals in Bangalore", "Chauffeur Mercedes Bangalore"],
  ["Executive Mercedes Taxi Bangalore", "Luxury Mercedes Hire Bangalore"],
  ["Mercedes Sedan Rental Bangalore", "Premium Mercedes Rental Bangalore"],
  ["Mercedes SUV Hire Bangalore", "Business Class Mercedes Bangalore"],
  ["Corporate Mercedes Car Rental Bangalore", "Affordable Mercedes Cab Bangalore"],
  ["Best Mercedes Cab Services Bangalore", "Mercedes with Driver Bangalore"],
  ["Online Mercedes Booking Bangalore", "Elite Mercedes Rental Bangalore"],
  ["Hire Mercedes Cab Bangalore", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Mercedes Cab Rentals in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers premium Mercedes cab rentals in Bangalore, delivering luxury and comfort for your travel needs."
  },
  {
    "WhyChooseheading": "Fleet of Elegant Mercedes Vehicles",
    "WhyChoosedescription": "Choose from a range of well-maintained Mercedes models, perfect for business trips, special occasions, and airport transfers."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs at Your Service",
    "WhyChoosedescription": "Our experienced drivers provide punctual, courteous, and safe rides, ensuring a premium travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Impeccably Maintained Cars",
    "WhyChoosedescription": "All Mercedes vehicles are regularly cleaned and sanitized to meet high standards of hygiene and safety."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive rental rates covering fuel, tolls, and driver allowances without any surprise costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and address any queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Needs",
    "WhyChoosedescription": "Customize your Mercedes rental plan for hourly, daily, or long-term use according to your schedule."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service Across Bangalore",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs anywhere in Bangalore for a hassle-free luxury travel experience."
  }
]
























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes cab rentals in Bangalore?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes cab rentals in Bangalore for business, events, and personal travel.',
  },
  {
    question: 'How can I book Mercedes cab rentals in Bangalore with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Bangalore.',
  },
  {
    question: 'What Mercedes models are available for rental in Bangalore?',
    answer: 'Aaryan Travels offers a range of luxury Mercedes models including C-Class, E-Class, and S-Class for cab rentals in Bangalore.',
  },
  {
    question: 'Are the drivers trained and experienced for Mercedes cab rentals in Bangalore?',
    answer: 'Absolutely. Our drivers are professionally trained, licensed, and committed to providing safe and comfortable rides.',
  },
  {
    question: 'Can I rent a Mercedes cab in Bangalore for special occasions or corporate use?',
    answer: 'Yes, our Mercedes cab rentals in Bangalore are ideal for weddings, corporate events, airport transfers, and VIP travel.',
  },
  {
    question: 'Is the Mercedes cab rental service available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels offers 24x7 Mercedes cab rental services to meet your travel needs anytime.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mercedes cab rentals?',
    answer: 'All Mercedes vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for Mercedes cab rentals in Bangalore?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mercedes cab rental period in Bangalore?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Shetty',
    feedback: 'Aaryan Travels provided a flawless Mercedes cab rental experience in Bangalore with professional drivers and punctual service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Nair',
    feedback: 'Highly recommend Aaryan Travels for Mercedes cab rentals in Bangalore. The cars were luxurious and the service was excellent.',
    rating: 5,
  },
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const mercedesCabBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Cab Rentals in Bangalore",
  "description": "Aaryan Travels provides premium Mercedes cab rentals in Bangalore. Choose from luxury sedans and SUVs with professional chauffeurs for corporate, executive, or personal travel.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Mercedes Cab Rentals",
  "keywords": "Mercedes Cab Rentals in Bangalore, Chauffeur Mercedes Bangalore, Executive Mercedes Taxi Bangalore, Luxury Mercedes Hire Bangalore, Mercedes Sedan Rental Bangalore, Premium Mercedes Rental Bangalore, Mercedes SUV Hire Bangalore, Business Class Mercedes Bangalore, Corporate Mercedes Car Rental Bangalore, Affordable Mercedes Cab Bangalore, Best Mercedes Cab Services Bangalore, Mercedes with Driver Bangalore, Online Mercedes Booking Bangalore, Elite Mercedes Rental Bangalore, Hire Mercedes Cab Bangalore"
};









  return (
    <div>

<Helmet>
  <title>Mercedes Cab Rentals in Bangalore | Luxury Mercedes Cars with Driver | Aaryan Travels</title>
  <meta
    name="description"
    content="Rent a Mercedes cab in Bangalore with Aaryan Travels. Enjoy premium chauffeur-driven Mercedes sedans and SUVs for corporate or luxury travel at affordable rates."
  />
  <meta
    name="keywords"
    content="Mercedes Cab Rentals in Bangalore, Chauffeur Mercedes Bangalore, Executive Mercedes Taxi Bangalore, Luxury Mercedes Hire Bangalore, Mercedes Sedan Rental Bangalore, Premium Mercedes Rental Bangalore, Mercedes SUV Hire Bangalore, Business Class Mercedes Bangalore, Corporate Mercedes Car Rental Bangalore, Affordable Mercedes Cab Bangalore, Best Mercedes Cab Services Bangalore, Mercedes with Driver Bangalore, Online Mercedes Booking Bangalore, Elite Mercedes Rental Bangalore, Hire Mercedes Cab Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesCabBangaloreSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedescabrentalsinbanglore;